<div class="row" style="margin-top: 50px;" *ngIf="!initialLoading">
    <div class="col-sm-12 center_div">
        <div class="">
            <h3 style="text-align:center;margin-top:10px">Contract session has not been started.  Please <a (click)="navigateToClientRemote()"> click here</a> to try again </h3>
            <h3 style="text-align:center;margin-top:10px">or Contact your Sales associate for help. </h3>
        </div>
        <div style="height:20px"></div>
    </div>
</div>
